/** @description always include jQuery in this manner in every file where jQuery is used */
/* eslint no-use-before-define: 0 */

const $ = jQuery.noConflict();

import {MarkerClusterer} from '@googlemaps/markerclusterer';

'use strict';
const GoogleMapsEmbed = {
	/**
	 * @description Init vars
	 * @type {object}
	 * @param {jQuery} $showMapButton
	 * @param {jQuery} $map
	 * @param {jQuery} $repElements
	 * @param {array} locations
	 * @param {array} createdMarkers
	 * @param {array} createdInfoWindows
	 * @param {object} activeMarker
	 * @param {object} map
	 * @param {float} defaultLat
	 * @param {float} defaultLng
	 * @param {string} iconUrl
	 * @param {string} iconUrlActive
	 * @param {object} cluster
	 */
	$showMapButton: $('.js-show-map-button'),
	$map: $('#map'),
	$repElements: [],
	locations: [],
	createdMarkers: {},
	createdInfoWindows: {},
	activeMarker: null,
	map: null,
	defaultLat: 40.730610,
	defaultLng: -73.935242,
	iconUrl: document.location.protocol + '//' + window.location.host + '/wp-content/themes/fws-eastern-tabletop/src/assets/images/map-marker.png',
	iconUrlActive: document.location.protocol + '//' + window.location.host + '/wp-content/themes/fws-eastern-tabletop/src/assets/images/map-marker-big.png',
	largeIcon: null,
	smallIcon: null,
	cluster: null,

	prevZoom: null,
	prevCenter: null,

	focusZoom: 13,
	clusterMaxZoom: 14,

	init: function($repElements) {
		const _this = this;
		this.$repElements = $repElements;
		if ($repElements) {
			_this.smallIcon = {
				url: _this.iconUrl,
				scaledSize: new google.maps.Size(32, 42),
			};

			_this.largeIcon = {
				url: _this.iconUrlActive,
				scaledSize: new google.maps.Size(48, 64),
			};

			this.$repElements.each(function(index, element) {
				const $element = $(element);
				if ($element.data('lat') && $element.data('lng')) {
					const locationInfo = {
						location: {
							lat: parseFloat($element.data('lat')),
							lng: parseFloat($element.data('lng'))
						},
						name: $element.find('.js-name').first().text() ?? '',
						address: $element.find('.js-address').first().text() ?? '',
						contact: $element.find('.js-contact').first().text() ?? '',
						phoneLink: $element.find('.js-phone-link').first().attr('href') ?? '',
						hasShowroom: $element.find('.js-has-showroom').length,
						openStatus: $element.find('.js-open-status').first().text() ?? '',
						openingMessage: $element.find('.js-opening-message').first().text() ?? '',
						workDaysList: $element.find('.js-work-day-list').first().html() ?? '',
						id: $element.data('id') ?? '',
					};
					_this.locations.push(locationInfo);
				}

				// Register extra showroom locations (from the `locations` repeater)
				const extraLocations = $element.data('extra-locations') || [];
				extraLocations.forEach(function(extraLoc, idx) {
					if (extraLoc.lat && extraLoc.lng) {
						// Each extra showroom is wrapper index idx+1 (index 0 is the main showroom)
						const $wrapper = $element.find('.dealer-tile__location-wrapper').eq(idx + 1);
						_this.locations.push({
							location: {lat: extraLoc.lat, lng: extraLoc.lng},
							name: $element.find('.js-name').first().text() ?? '',
							address: $wrapper.find('.js-address').text() ?? '',
							contact: $wrapper.find('.js-contact').text() ?? '',
							phoneLink: $wrapper.find('.js-phone-link').attr('href') ?? '',
							hasShowroom: $wrapper.find('.js-has-showroom').length,
							openStatus: $wrapper.find('.js-open-status').text() ?? '',
							openingMessage: $wrapper.find('.js-opening-message').text() ?? '',
							workDaysList: $wrapper.find('.js-work-day-list').html() ?? '',
							id: extraLoc.id,
							cardId: String(extraLoc.tileId),
						});
					}
				});
			});
			this.initMap();
			this.attachViewLinkEvents();
		}
	},

	/**
	 * Attaches delegated click events for "View on Map" links.
	 * Uses the marker-id stored in data-marker-id to pan to the specific pin.
	 */
	attachViewLinkEvents: function() {
		const _this = this;
		$(document).off('click.viewLink', '.js-view-link').on('click.viewLink', '.js-view-link', function(e) {
			e.stopPropagation();
			const markerId = String($(this).data('marker-id'));
			if (markerId) {
				_this.updateCurrentMarker(markerId);
			}
		});
	},

	/**
	 * Initializes map on the page, with all centers and user location pinned
	 *
	 * @description Initialize Map based on location
	 */
	initMap: async function() {
		const _this = this;

		if (typeof google !== 'undefined') {
			// eslint-disable-next-line no-undef
			_this.map = new google.maps.Map(document.getElementById('map'), {
				zoom: 3,
				center: {lat: _this.defaultLat, lng: _this.defaultLng},
				disableDefaultUI: true,
				styles: [
					{
						'featureType': 'administrative',
						'elementType': 'labels.text.fill',
						'stylers': [
							{
								'color': '#444444'
							}
						]
					},
					{
						'featureType': 'landscape',
						'elementType': 'all',
						'stylers': [
							{
								'color': '#f2f2f2'
							}
						]
					},
					{
						'featureType': 'poi',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'poi.park',
						'elementType': 'geometry',
						'stylers': [
							{
								'hue': '#ff0000'
							}
						]
					},
					{
						'featureType': 'poi.park',
						'elementType': 'geometry.fill',
						'stylers': [
							{
								'color': '#000000'
							}
						]
					},
					{
						'featureType': 'road',
						'elementType': 'all',
						'stylers': [
							{
								'saturation': -100
							},
							{
								'lightness': 45
							}
						]
					},
					{
						'featureType': 'road.highway',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'simplified'
							}
						]
					},
					{
						'featureType': 'road.arterial',
						'elementType': 'geometry',
						'stylers': [
							{
								'color': '#969532'
							}
						]
					},
					{
						'featureType': 'road.arterial',
						'elementType': 'labels.text',
						'stylers': [
							{
								'visibility': 'simplified'
							},
							{
								'color': '#504f4f'
							},
							{
								'lightness': '98'
							},
							{
								'weight': '2.47'
							},
							{
								'invert_lightness': true
							}
						]
					},
					{
						'featureType': 'road.arterial',
						'elementType': 'labels.icon',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'road.local',
						'elementType': 'geometry',
						'stylers': [
							{
								'color': '#969532'
							},
							{
								'lightness': '53'
							}
						]
					},
					{
						'featureType': 'road.local',
						'elementType': 'labels.text',
						'stylers': [
							{
								'lightness': '-47'
							},
							{
								'saturation': '-14'
							},
							{
								'visibility': 'simplified'
							},
							{
								'color': '#504f4f'
							}
						]
					},
					{
						'featureType': 'road.local',
						'elementType': 'labels.text.fill',
						'stylers': [
							{
								'color': '#504f4f'
							}
						]
					},
					{
						'featureType': 'road.local',
						'elementType': 'labels.text.stroke',
						'stylers': [
							{
								'color': '#ff0000'
							}
						]
					},
					{
						'featureType': 'transit',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit.line',
						'elementType': 'labels',
						'stylers': [
							{
								'color': '#ff0000'
							}
						]
					},
					{
						'featureType': 'transit.station.bus',
						'elementType': 'labels.text',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#7d7d7d'
							}
						]
					},
					{
						'featureType': 'transit.station.rail',
						'elementType': 'geometry',
						'stylers': [
							{
								'color': '#ff0000'
							}
						]
					},
					{
						'featureType': 'transit.station.rail',
						'elementType': 'labels.text.fill',
						'stylers': [
							{
								'color': '#8f0909'
							}
						]
					},
					{
						'featureType': 'transit.station.rail',
						'elementType': 'labels.icon',
						'stylers': [
							{
								'color': '#7a0b0b'
							}
						]
					},
					{
						'featureType': 'water',
						'elementType': 'all',
						'stylers': [
							{
								'color': '#969532'
							},
							{
								'visibility': 'on'
							}
						]
					},
					{
						'featureType': 'water',
						'elementType': 'geometry',
						'stylers': [
							{
								'color': '#d2eff0'
							}
						]
					}
				]
			});

			const markers = _this.locations.map((location) => {
				const marker = new google.maps.Marker({
					position: location.location,
					map: _this.map,
					icon: {
						url: _this.iconUrl,
						scaledSize: new google.maps.Size(32, 42),
					},
					animation: google.maps.Animation.DROP,
				});

				// eslint-disable-next-line no-undef
				const infoWindow = new google.maps.InfoWindow({
					content: '',
					disableAutoPan: true,
				});

				let workDaysContent = '';
				if (location.openStatus && location.openingMessage && location.workDaysList) {
					const statusModifier = location.openStatus.trim().toLowerCase() === 'open' ? 'dealer-tile__status--open' : 'dealer-tile__status--close';
					workDaysContent = `<div class='dealer-tile__hours'>
						<span class='dealer-tile__status ${statusModifier}'>${location.openStatus}</span>
						<div class='dealer-tile__hours-toggle'>
							<span class='dealer-tile__hours-upfront'>${location.openingMessage}</span>
							<ul class='dealer-tile__hours-list'>
								${location.workDaysList}
							</ul>
						</div>
					</div>`;
				}

				const showRoomText = location.hasShowroom ? '<p class=\'dealer-tile__location\'><strong>Showroom:</strong></p>' : '';
				infoWindow.setContent(`<div class='dealer-tile__infobox'>
						<h3 class='dealer-tile__name'>${location.name}</h3>
						<div class='dealer-tile__infobox-info'>
							<span class="js-distance-span"></span>
							${workDaysContent}
						</div>
						${showRoomText}
						<p class='dealer-tile__location'>${location.address}</p>
						<a href='${location.phoneLink}'>
							<p class='dealer-tile__contact'>${location.contact}</p>
						</a>
					</div>`);

				marker.addListener('click', () => {
					Object.values(_this.createdInfoWindows).forEach(function(window) {
						if (infoWindow === window) {
							if (infoWindow.getMap()) {
								infoWindow.close();
							} else {
								infoWindow.open(_this.map, marker);
							}
						} else if (window.getMap()) {
							window.close();
						}
					});

					_this.saveMapState();

					_this.map.panTo(location.location);

					setTimeout(() => _this.map.setZoom(15), 200);

					if (_this.activeMarker && _this.activeMarker !== marker) {
						_this.activeMarker.setIcon(_this.smallIcon);
					}

					if (_this.activeMarker === marker) {
						marker.setIcon(_this.smallIcon);
					} else {
						marker.setIcon(_this.largeIcon);
					}

					_this.activeMarker = marker;
					// For extra-showroom markers, highlight the parent card
					_this.changeActiveCard(location.cardId || location.id);
				});

				infoWindow.addListener('closeclick', () => {

					_this.restoreMapState();

					if (_this.activeMarker === marker) {
						marker.setIcon(_this.smallIcon);
						_this.activeMarker = null;
					}
				});

				_this.createdInfoWindows[location.id] = infoWindow;
				_this.createdMarkers[location.id] = marker;

				return marker;
			});

			// eslint-disable-next-line no-new, no-undef
			if (typeof MarkerClusterer !== 'undefined') {
				_this.cluster = new MarkerClusterer({
					markers,
					map: _this.map,
				});

				_this.cluster.addListener('click', (arg1, arg2) => {
					let clusterObj = null;
					if (arg1 && arg1.cluster) clusterObj = arg1.cluster;
					else if (arg2 && arg2.markers) clusterObj = arg2;
					else clusterObj = arg1;

					const clusterMarkers = clusterObj.markers ||
						(typeof clusterObj.getMarkers === 'function' ? clusterObj.getMarkers() : null);

					if (clusterMarkers && clusterMarkers.length > 0) {
						const bounds = new google.maps.LatLngBounds();
						clusterMarkers.forEach(m => bounds.extend(m.getPosition()));

						if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
							_this.map.panTo(bounds.getCenter());
							_this.map.setZoom(16);
						} else {
							_this.map.fitBounds(bounds, 50);
							google.maps.event.addListenerOnce(_this.map, 'idle', () => {
								if (_this.map.getZoom() > 17) _this.map.setZoom(15);
							});
						}
					}
				});
			} else {
				console.warn('MarkerClusterer is not defined');
			}
		}
	},

	/**
	 * Called from searchRepLocations. Will update the current active marker on the map, based on the passed ID.
	 * @param markerId
	 */
	updateCurrentMarker: function(markerId) {
		const _this = this;
		const selectedMarker = _this.createdMarkers[markerId];

		if (!selectedMarker) return;

		if (_this.activeMarker && _this.activeMarker !== selectedMarker) {
			_this.activeMarker.setIcon(_this.smallIcon);
		}

		selectedMarker.setIcon(_this.largeIcon);
		_this.activeMarker = selectedMarker;

		Object.values(_this.createdInfoWindows).forEach(function(window) {
			if (window.getMap()) {
				window.close();
			}
		});

		if (typeof _this.map.panTo === 'function') {
			_this.map.panTo(selectedMarker.getPosition());
			_this.map.setZoom(_this.focusZoom);
		} else {
			_this.map.setOptions({center: selectedMarker.getPosition()});
		}

		const openInfoWindow = function() {
			if (_this.createdInfoWindows[markerId]) {
				_this.createdInfoWindows[markerId].open(_this.map, selectedMarker);
			}
		};

		google.maps.event.addListenerOnce(_this.map, 'idle', openInfoWindow);
	},

	/**
	 * Changes active card from the tiles section of the page.
	 * @param locationId
	 */
	changeActiveCard: function(locationId) {
		const $target = $('.js-single-tile[data-id="' + locationId + '"]');

		$('.js-single-tile.is-active').removeClass('is-active');
		$target.addClass('is-active');

		setTimeout(function() {
			const viewportHeight = $(window).height();
			const elementTop = $target.offset().top;
			const elementHeight = $target.outerHeight();

			const scrollTo = elementTop - (viewportHeight / 2) + (elementHeight / 2);

			$('html, body').animate({
				scrollTop: scrollTo
			}, 300, 'linear');
		}, 300);
	},

	saveMapState() {
		this.prevZoom = this.map.getZoom();
		this.prevCenter = this.map.getCenter();
	},

	restoreMapState() {
		if (this.prevZoom !== null && this.prevCenter) {
			this.map.setZoom(this.prevZoom);
			this.map.panTo(this.prevCenter);
		}
		Object.values(this.createdInfoWindows).forEach(function(window) {
			const existingContent = window.getContent();
			const updatedContent = existingContent.replace(
				/(<span class="js-distance-span">)(.*?)(<\/span>)/,
				''
			);
			window.setContent(updatedContent);
			window.close();
		});
		if (this.activeMarker) {
			this.activeMarker.setIcon(this.smallIcon);
		}
	},

	/**
	 * Hides markers based on passed in Marker IDs
	 * @param markers
	 */
	hideMarkers: function(markers) {
		const visibleMarkers = [];
		Object.values(this.createdInfoWindows).forEach(window => window.close());
		if (this.activeMarker) {
			this.activeMarker.setIcon(this.smallIcon);
			this.activeMarker = null;
		}
		Object.entries(this.createdMarkers).forEach(([markerId, marker]) => {
			if (markers.includes(String(markerId))) {
				marker.setMap(null);
				marker.setVisible(false);
			} else {
				marker.setMap(this.map);
				marker.setVisible(true);
				visibleMarkers.push(marker);
			}
		});
		if (this.cluster) {
			this.cluster.clearMarkers();
			this.cluster.addMarkers(visibleMarkers);
		}

		if (visibleMarkers.length > 0) {
			const bounds = new google.maps.LatLngBounds();
			visibleMarkers.forEach(marker => bounds.extend(marker.getPosition()));
			this.map.fitBounds(bounds, 80);
			google.maps.event.addListenerOnce(this.map, 'idle', () => {
				if (this.map.getZoom() > 10) this.map.setZoom(15);
			});
		}
	},

	showAllMarkers: function() {
		const allMarkers = [];
		Object.values(this.createdInfoWindows).forEach(function(window) {
			window.close();
		});
		if (this.activeMarker) {
			this.activeMarker.setIcon(this.smallIcon);
			this.activeMarker = null;
		}
		// eslint-disable-next-line
		Object.entries(this.createdMarkers).forEach(([markerId, marker]) => {
			marker.setMap(this.map);
			marker.setVisible(true);
			allMarkers.push(marker);
		});
		if (this.cluster) {
			this.cluster.clearMarkers();
			this.cluster.addMarkers(allMarkers);
		}
		this.map.setZoom(4);
		this.map.setCenter({lat: this.defaultLat, lng: this.defaultLng});
	},

};

export default GoogleMapsEmbed;
